export default function Footer() {
  return (
    <footer>
      © WangLaw 2014-2023 – art direction : Benjamin Lignel / Development : <a href='https://www.linkedin.com/in/anthony-ringressi/' target='_blank'  rel="noreferrer">Anthony Ringressi</a> / Home page illustration: Emmanuelle Duparchy / Portrait Nina Wang: Robert Wiwatowski
    </footer>
  )
}